"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlightTransitionMobile = function SvgFlightTransitionMobile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 18",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 6)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EBECF0",
    d: "M0 10s5.702-3.3 18.097-3.3C30.49 6.7 36.193 10 36.193 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 10.5,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#179FE3",
    d: "M10.021 1.647C12.303.714 14.99.091 18.097.091 30.49.091 36.193 10 36.193 10"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 6)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EBECF0",
    d: "M0 10s5.856-3.3 18.586-3.3C31.316 6.7 37.17 10 37.17 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 10.5,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#179FE3",
    d: "M0 10S5.856.091 18.586.091C31.316.091 37.17 10 37.17 10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.68 13.179-2.433 1.482s-.646.499-1.863.25c-1.218-.25-2.467-.524-2.467-.524s-.268-.097-.452.14c-.185.238.119.38.119.38l1.878 1.352s.4.394.99.29c.59-.103 2.325-.453 2.325-.453s1.184-.251 2.592-1.124c1.408-.872 6.441-3.907 6.441-3.907s1.959-1.106 1.762-1.569c-.196-.463-1.325-.34-1.865-.17s-4.755 2.543-4.755 2.543l-4.619-1.573s-.597-.141-.298.205c.298.347 3.225 3.24 3.225 3.24m1.32 1.612 1.255 1.243s.365.287.438-.711c.074-.999.148-1.746.148-1.746M89.707 5.412l-2.71-.734s-.797-.122-1.429-1.165a204.5 204.5 0 0 1-1.266-2.126s-.108-.258-.406-.228c-.297.03-.197.344-.197.344l.267 2.268s-.02.556.45.908c.47.353 1.885 1.358 1.885 1.358s.976.678 2.555 1.092c1.58.415 7.164 1.954 7.164 1.954s2.119.65 2.326.194c.208-.457-.638-1.182-1.123-1.454-.485-.271-5.038-1.675-5.038-1.675l-1.939-4.385s-.295-.524-.35-.074c-.053.45-.213 4.523-.213 4.523m-.295 2.046-.07 1.747s.033.457.813-.171c.78-.628 1.375-1.085 1.375-1.085",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFlightTransitionMobile);
var _default = exports["default"] = Memo;